import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M7.376 2.673C8.926 1.433 10.946 1 13 1c2.073 0 4.026.656 5.456 1.294v5.679a15 15 0 0 0-1.718-.966C15.567 6.45 14.21 6 13 6c-1.447 0-2.176.318-2.5.577-.23.184-.5.523-.5 1.423v.02c-.003.088-.006.198.37.469.532.384 1.327.71 2.536 1.181l.13.05c1.029.4 2.413.937 3.522 1.738C17.84 12.384 19 13.842 19 16c0 2.1-.73 4.011-2.376 5.327C15.074 22.567 13.054 23 11 23c-2.113 0-4.101-.682-5.538-1.33v-5.698c.046.032.203.138.445.287.325.198.794.466 1.355.734C8.434 17.55 9.79 18 11 18c1.447 0 2.176-.318 2.5-.577.23-.184.5-.523.5-1.423v-.02c.003-.088.006-.198-.37-.469-.532-.384-1.327-.71-2.536-1.181l-.13-.05c-1.029-.4-2.413-.937-3.521-1.738C6.16 11.616 5 10.158 5 8c0-2.1.73-4.011 2.376-5.327"
    }, null, -1)
  ]));
}
const brandPaymentsStripe = { render };
export {
  brandPaymentsStripe as default,
  render
};
//# sourceMappingURL=brand-payments-stripe.svg.js.map
